async function initAppShadowForms() {
  const wrapper = document.querySelector('[data-request_checkout_forms]');
  if (!wrapper) return;

  const authFlag = document.querySelector("[data-request_checkout_auth]");
  if (authFlag) {
    if (authFlag.dataset.hasOwnProperty("redirect_to")) {
      document.location.assign(authFlag.dataset.redirect_to);
    } else {
      authFlag.parentElement.removeChild(authFlag);
    }
  }

  const catalogModeFlag = document.querySelector("[data-catalog_mode_enabled]");
  if (catalogModeFlag) {
    catalogModeFlag.parentElement.removeChild(catalogModeFlag);
  }

  const requestedUrl = new URL(document.location.href);
  const routes = {
    'home': '/',
    'person-type': 'pages/perfil-basico',
    'personal-documents': 'pages/perfil-de-cliente',
    'form-failed': 'pages/perfil-basico-no-validado',
    'checkout': 'checkout'
  };
  const availableCheckoutSteps = ["personal-info", "personal-documents"];
  const checkoutStep = wrapper.dataset.request_checkout_forms;
  const scopeSearchParam = "tipo_persona";
  const requestedParams = new URLSearchParams(requestedUrl.search);
  const personType = requestedParams.get(scopeSearchParam);

  if (!availableCheckoutSteps.includes(checkoutStep)) {
    return redirectToPage('form-failed');
  }
  
  if (!requestedUrl.search) {
    return redirectToPage('person-type');
  }

  if (!requestedParams.has(scopeSearchParam)) {
    return redirectToPage('person-type');
  }

  const appFormContainer = getShadowFormContainer(wrapper, personType);
  if (!appFormContainer) return;
  

  const curpRegex =
    /^([A-Za-z][AEIOUXaeioux][A-Za-z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])(?:H|M|h|m)(?:(A|a)(S|s)|(B|b)(C|c)|(B|b)(S|s)|(C|c)(C|c)|(C|c)(L|l)|(C|c)(M|m)|(C|c)(S|s)|(C|c)(H|h)|(D|d)(F|f)|(D|d)(G|g)|(G|g)(T|t)|(G|g)(R|r)|(H|h)(G|g)|(J|j)(C|c)|(M|m)(C|c)|(M|m)(N|n)|(M|m)(S|s)|(N|n)(E|e)|(N|n)(T|t)|(N|n)(L|l)|(O|o)(C|c)|(P|p)(L|l)|(Q|q)(T|t)|(Q|q)(R|r)|(S|s)(P|p)|(S|s)(L|l)|(S|s)(R|r)|(T|t)(C|c)|(T|t)(S|s)|(T|t)(L|l)|(V|v)(Z|z)|(Y|y)(N|n)|(Z|z)(S|s))[A-Za-z\d]{3}[A-Za-z\d])(\d)$/;
  const rfcRegex = /^[A-Za-zÑñ&]{3,4}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[A-Za-z\d]{3}$/;

  const shadowForm = await setupShadowForm(appFormContainer, personType);
  if (!shadowForm) {
    return redirectToPage('form-failed');
  }

  //if (checkoutStep === "personal-documents") return;

  if (checkoutStep === "personal-info") {
    const formSubmit = shadowForm.querySelector("button[type='submit']");
    formSubmit.addEventListener("click", handleSubmitButtonClicked);
  }

  shadowForm.addEventListener("submit", handleShadowFormSubmit);

  function getShadowFormContainer(parent, scope) {
    const containers = parent.querySelectorAll('[data-app_form]');
    if (containers.length === 1) {
      const [container] = containers;
      return container;
    }

    let containerIndex = -1;
    containers.forEach((container, index) => {
      if (container.dataset.app_form === scope) {
        containerIndex = index;
      } else {
        container.parentElement.removeChild(container);
      }
    });
    
    return containers[containerIndex];
  }

  async function setupShadowForm(container, scope) {
    const form = await attemptGetAppShadowForm(container);
    if (!form) {
      return false;
    }

    setShadowFormStyles(form, container.querySelector('shopify-forms-embed#app-embed').shadowRoot, scope);
    showShadowFormContainer(container);

    return form;
  }

  async function handleSubmitButtonClicked(event) {
    const button = event.currentTarget;
    
    toggleSubmitButtonState(button, false);

    const fields = {};

    const fieldContainers = shadowForm.querySelectorAll("div[class*='_formFieldContainer_']");
    fieldContainers.forEach(container => {
      const input = container.querySelector("input");
      const fieldname = container.parentElement.className.includes("_dateFieldContainer_")
        ? getDateInputFieldname(input.id)
        : input.id.replace("custom#", "");
      fields[fieldname] = container.className.includes("_withError_") ? "" : input.value;
    });

    const validated = validateFormData(fields, personType);

    if (!validated) {
      toggleSubmitButtonState(button, true);
      return true;
    }

    const verified = await verifyFormData(fields, personType);
    if (!verified) {
      console.log("shadow form data was rejected");
      event.preventDefault();
      return redirectToPage('form-failed');
    }
    
    console.log("shadow form is ready to submit");
    toggleSubmitButtonState(button, true);
    button.removeEventListener("click", handleSubmitButtonClicked);
    button.click();
  }

  function validateFormData(input, scope) {
    const counter = { fields: 0, values: 0 };

    for (const fieldname in input) {
      counter.fields++;
      if (input[fieldname] !== "") counter.values++;
    }

    if (counter.fields !== counter.values) {
      return false;
    }

    /* const rfcDate = `${input['YYYY'].slice(-2)}${input['MM']}${input['DD']}`;
    if (!input['rfc'].includes(rfcDate)) {
      return false;
    } */

    if (!rfcRegex.test(input['rfc']) || (scope === "fisica" && !curpRegex.test(input['curp']))) {
      return false;
    }

    return true;
  }

  async function verifyFormData(input, scope) {
    const genericRfcExceptions = ["xaxx010101000", "xexx010101000"];
    try {
      const rfcDate = `${input['year'].slice(-2)}${input['month']}${input['day']}`;
      if (!genericRfcExceptions.includes(input['rfc']) && !input['rfc'].includes(rfcDate)) {
        throw new Error("RFC date invalid");
      }
    } catch (error) {
      console.error(error);
      return false;
    }

    const finalDate = `${input['year']}-${input['month']}-${input['day']}`;
    const body = {
      nombre: scope === "fisica" ? input['first_name'] : "",
      apellidopaterno: scope === "fisica" ? input['apellido_paterno'] : "",
      apellidomaterno: scope === "fisica" ? input['apellido_materno'] : "",
      razonsocial: scope === "moral" ? input['first_name'] : "",
      rfc: input['rfc'],
      curp: scope === "fisica" ? input['curp'] : "",
      fechanacimiento: finalDate,
      correo: input['email'],
      telefono: input['telfono_1'],
    };
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const options = {
      method: 'POST',
      headers,
      mode: 'cors',
      body: JSON.stringify(body),
    };

    const promise = await attemptFetch('fetching account data verification', 'https://eoi91vajbji52i6.m.pipedream.net', options, 5);
    if (!promise) {
      return false;
    }
    const data = await promise.json();
    const verified = data.ClienteValido;
    
    return verified;
  }

  function setShadowFormStyles(form, root, scope) {
    const styleBlock = document.querySelector("style#app-shadow-form-styles");
    root.appendChild(styleBlock);

    const formDialog = root.querySelector("section[data-sizing][role='dialog'][aria-label]");
    //formDialog.removeAttribute("class");

    const formHeader = root.querySelector("section[class*='_formHeader_']");
    formHeader.setAttribute("aria-hidden", "true");

    const formDisclaimer = root.querySelector("div[class*='_formDisclaimer_']");
    formDisclaimer.setAttribute("aria-hidden", "true");

    const fieldContainers = form.querySelectorAll("div[class*='_formFieldContainer_']");
    fieldContainers.forEach(container => {
      const input = container.querySelector("input");
      const label = container.querySelector("label");

      if (container.parentElement.className.includes("_dateFieldContainer_")) {
        input.placeholder = label.textContent;
      }

      label.textContent += "*";

      if (checkoutStep === "personal-documents") {
        container.setAttribute("data-hidden_field", "true");
        container.setAttribute("hidden", "");
      }

      if (input.id === "email") {
        input.disabled = true;
      }
    });

    const fieldsetContainers = form.querySelectorAll("fieldset[class*='_radioFieldSet_']");
    fieldsetContainers.forEach(container => {
      if (checkoutStep === "personal-info") {
        console.log(container.name);
        if (container.name.includes("tipo_de_persona")) {
          const input = container.querySelector(`input[value="${scope}"]`);
          input.click();
        }

        if (container.name.includes("datos_personales_verificados")) {
          const input = container.querySelector("input[value='verificado']");
          input.click();
        }

        container.setAttribute("data-hidden_field", "true");
        container.setAttribute("hidden", "");
      }
    });

    const fileContainers = form.querySelectorAll("div[class*='_formFileInput_']");
    fileContainers.forEach(container => {
      const label = container.querySelector("p[class*='_textBody_']");
      label.textContent += "*";
    });
    
    const birthdayContainers = form.querySelectorAll("div[data-testid='date-birthday']");
    birthdayContainers.forEach(container => {
      const label = container.querySelector("div[class*='_birthdayText_']");
      label.className = "text-sm sm:text-base text-color-scheme";
      label.textContent += "*";
    });
  }

  function fetchAppShadowForm(container) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(findAppShadowForm(container));
      },500)
    });
  }
  function findAppShadowForm(container) {
    const shadowHost = container.querySelector('shopify-forms-embed#app-embed');
    if (!shadowHost || !shadowHost.shadowRoot) {
      return false;
    }
    const form = shadowHost.shadowRoot.querySelector("form");
    if (!form) {
      return false;
    }

    return form;
  }
  async function attemptGetAppShadowForm(container, attempts = 5) {
    if (attempts === 0) {
      console.error(new Error("App shadow form was not found."));
      return false;
    }
    const promise = await fetchAppShadowForm(container);
    if (!promise) {
      console.warn("App shadow form is not ready yet.");
      return await attemptGetAppShadowForm(container, attempts -1);
    }
    
    return promise;
  }

  function handleShadowFormSubmit(event) {
    const appFormRouter = appFormContainer.querySelector('shopify-forms-embed#app-embed').shadowRoot.querySelector("[data-testid='app-router']");
    if (!appFormRouter) {
      return;
    }

    const mutations = new MutationObserver((records, observer) => {
      records.forEach(record => {
        if (record.addedNodes.length > 0) {
          observer.disconnect();

          const formFooter = wrapper.querySelector("[data-form_footer]");
          if (!formFooter) {
            return;
          }

          formFooter.classList.add("hidden");
          formFooter.setAttribute("aria-hidden", "true");

          setTimeout(() => {
            if (checkoutStep === "personal-info") {
              requestedUrl.searchParams.set(scopeSearchParam, personType);
              redirectToPage('personal-documents');
            } else if (checkoutStep === "personal-documents") {
              requestedUrl.searchParams.delete(scopeSearchParam);
              if (catalogModeFlag) {
                redirectToPage('home');
              } else {
                redirectToPage('checkout');
              }
            }
          }, 1000);
        }
      });
    });
    mutations.observe(appFormRouter, { childList: true });
  }

  function redirectToPage(route) {
    requestedUrl.pathname = routes[route];
    document.location.assign(requestedUrl.href);
  }

  function showShadowFormContainer(container) {
    container.classList.remove('hidden');
    container.removeAttribute('hidden');
    container.removeAttribute('aria-hidden');
  }

  function toggleSubmitButtonState(button, enable) {
    button.disabled = !enable;
    button.classList.toggle("cursor-wait", !enable);
  }

  function getDateInputFieldname(inputId) {
    let fieldname = inputId;
    const availableNames = ["year", "month", "day"];
    availableNames.forEach(name => {
      if (inputId.toLowerCase().includes(name.toLowerCase())) {
        fieldname = name.toLowerCase();
      }
    });

    return fieldname;
  }
}

document.addEventListener('DOMContentLoaded', initAppShadowForms);
